module.exports = __webpack_public_path__ + "static/hero-img-desktop-df9af58c553315c2eb2a414bf28102ef.jpg";